export default __webpack_public_path__ + "static/media/openingscreen.441e17ae.png";